export default {
  title: {
    en: 'Welcome to Scentbird',
  },
  text: {
    en: 'Take the quiz and we will recommend you the scents you will fall in love with.',
  },
  buttonText: {
    en: 'Get started',
  },
}
